import Request from "./index";

class api {
  //【前台】获取直播列表（分页）
  static getLivePage(data) {
    return Request.get("/live/page", {
      params: data
    });
  }
  //【前台】获取跨平台直播列表（分页）
  static getCrossLiveList(data) {
    return Request.get("/live/cross/page", {
      params: data
    });
  }
}

export default api;
